import React from 'react';
import { Box, Chip } from '@material-ui/core';
import i18next from 'i18next';
import { DateFormatter } from 'components/AppTable/CellsComponents';

const formatStatus = value => i18next.t(`trainingModules.statuses.${value}`, { defaultValue: value });

const renderNameWithUpdateChip = (name, hasPendingUpgrades) => (
  <Box display="flex" alignItems="center" style={{ gap: 8, flexWrap: 'wrap' }}>
    <span>{name}</span>
    {hasPendingUpgrades ? (
      <Chip
        size="small"
        label={i18next.t('companyProvisioning.pendingUpdate', 'Updates are available.')}
        style={{ backgroundColor: '#FFF3E0', color: '#E65100', fontWeight: 600 }}
      />
    ) : null}
  </Box>
);

const getTableConfig = () => {
  return [
    {
      title: i18next.t('tablesLabels.id'),
      field: 'id',
      columnWidth: '80px',
      isSorting: true,
    },
    {
      title: i18next.t('trainingModules.code'),
      field: 'code',
      columnWidth: '140px',
      isSorting: true,
    },
    {
      title: i18next.t('tablesLabels.title'),
      field: 'name',
      columnWidth: '240px',
      isSorting: true,
      dependentField: 'hasPendingUpgrades',
      Component: renderNameWithUpdateChip,
    },
    {
      title: i18next.t('tablesLabels.description'),
      field: 'description',
      columnWidth: '400px',
      Component: value => value || '—',
    },
    {
      title: i18next.t('tablesLabels.status'),
      field: 'status',
      columnWidth: '120px',
      isSorting: true,
      Component: formatStatus,
    },
    {
      title: i18next.t('tablesLabels.lastUpdate'),
      field: 'updatedAt',
      columnWidth: '180px',
      isSorting: true,
      Component: value => <DateFormatter value={value} />,
    },
    {
      title: '',
      field: 'companyId',
      isVisible: false,
    },
    {
      title: '',
      field: 'isFromSystem',
      isVisible: false,
    },
    {
      title: '',
      field: 'hasPendingUpgrades',
      isVisible: false,
    },
  ];
};

export default getTableConfig;
